export default "__VITE_ASSET__0cd70650__"